import passwordValidator from "password-validator";
let schema = new passwordValidator();

const setRules = rules => {
  if (rules) {
    const { capitals, nonAlphanumeric, digits, length } = rules;
    if (capitals && capitals > 0) {
      schema.has().uppercase();
    }
    if (nonAlphanumeric && nonAlphanumeric > 0) {
      schema.has().symbols();
    }
    if (digits && digits > 0) {
      schema.has().digits();
    }
    if (length && length > 0) {
      schema.is().min(length);
    }
  }
};

const validate = (values, language, rules, info) => {
  // const { language } = props;
  setRules(rules);

  const errors = {};
  if (!values.newPassword) {
    errors.newPassword = language.PasswordValidation.noNewPassword;
  } else if (!schema.validate(values.newPassword)) {
    errors.newPassword = info;
  }
  if (!values.confirmPassword) {
    errors.confirmPassword =
      language.PasswordValidation.noNewPasswordVerification;
  } else if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = language.PasswordValidation.passwordNotVerified;
  }

  return errors;
};

export default validate;
